import {useState} from 'react';
import {Modal, Button, Row, Col} from 'react-bootstrap';

export const ConfirmFeatureToggle = (props) => {
  const {
    title,
    onChange, 
    button = false, 
    buttontext = '', 
    variant = 'primary',
    showconfirm = false,
    handleclose = () => {},
    message = ''
  } = props;
  
  const handleConfirm = () => {
    onChange();
    if(showconfirm) {
      handleclose();
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showconfirm}
        onHide={handleclose}
        animation={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm {title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="align-items-center">
            <Col className="align-self-center">
              <b className="text-center">{message}</b>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-center">
            <Button onClick={handleclose} variant="secondary">Cancel</Button> 
            <Button onClick={handleConfirm} className="ms-2">Confirm</Button> 
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ConfirmFeatureToggle;
